import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const reportsService = {
  // Estimated Instance Revenue Report
  getEstimatedInstanceRevenue: () => 
    ApiClient.get("reports/estimated-instance-revenue/get_estimated_instance_revenue"),
  
  getReportForRegion: (regionName: string) => 
    ApiClient.get("reports/estimated-instance-revenue/get_report_for_region", {
      params: { region_name: regionName }
    }),
  
  combineRegionReports: (regionReports: string) => 
    ApiClient.post("reports/estimated-instance-revenue/combine_region_reports", {
      region_reports: regionReports
    }),

  // Yearly Revenue Report
  getYearlyRevenueReport: (forYear?: number) => {
    const params = forYear ? { for_year: forYear } : {};
    return ApiClient.get("reports/yearly-revenue/get_yearly_revenue", { params });
  },

  // Revenue Reports (Historic revenue per region)
  getRevenueReportsList: (queries: Partial<QueriesApi> = {}) => {
    const {
      page,
      pageSize,
      page_size,
      ordering,
      ...rest
    } = queries || {};

    return ApiClient.get("revenue_reports", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        ...rest,
      },
    });
  },

  getRevenueReportDetail: (id: string | number) => 
    ApiClient.get(`revenue_reports/${id}`),

  generateRevenueReport: (month: number, year: number) => 
    ApiClient.post("revenue_reports/trigger_revenue_report_generation", {
      month,
      year
    }),

  regenerateRevenueReport: (id: string | number) => 
    ApiClient.post(`revenue_reports/${id}/regenerate_report`),

  getRevenueReportPermissions: () => 
    ApiClient.get("revenue_reports/permissions"),
};

export default reportsService;

